import { render, staticRenderFns } from "./imgTextMessage.vue?vue&type=template&id=29d10292&scoped=true"
import script from "./imgTextMessage.vue?vue&type=script&lang=js"
export * from "./imgTextMessage.vue?vue&type=script&lang=js"
import style0 from "./imgTextMessage.vue?vue&type=style&index=0&id=29d10292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d10292",
  null
  
)

export default component.exports